export const ASSET_TYPES = ["Keg", "Fridge", "Cylinder", "BeerTap"] as const
export type AssetType = typeof ASSET_TYPES[number]

export interface AssetTypeInfo {
  type: AssetType
  key: string
}

export function assetTypeLabel(type: AssetType, t: (key: string) => string): string {
  return t(`assetTypes.${assetTypeKey(type)}`)
}

export function assetTypeKey(type: AssetType): string {
  const map: Record<AssetType, string> = {
    Keg: "keg",
    Fridge: "fridge",
    Cylinder: "cylinder",
    BeerTap: "beerTap",
  }
  return map[type]
}
